export const RESERVED_CHANNEL_MESSAGE =
  'That channel name is reserved and cannot be used for a profile address.';

export function reservedLoginMessage(error: unknown): string | null {
  if (!error || typeof error !== 'object') return null;
  const body = (error as { data?: { message?: unknown } }).data?.message;
  const direct = (error as { message?: unknown }).message;
  const message = typeof body === 'string' ? body : direct;
  return message === RESERVED_CHANNEL_MESSAGE ? RESERVED_CHANNEL_MESSAGE : null;
}
